import { Component, OnDestroy, OnInit } from '@angular/core';
import { STATE_BROWSELIST, STATE_REPORT } from '../../../shared/app-states';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { BrowseListConfigService } from '../../../shared/browselists/browselists-config.service';
import { IReportResponse, IReportRow, ReportDataService } from '../../../shared/report/report-data.service';
import { MaxWidth, ResponsiveService } from '../../../shared/responsive/responsive.service';
import { util } from '../../../shared/util';
import * as _ from 'underscore';

const REPORT_ID:string = '94';

@Component({
  selector: 'browselist-usage',
  template: `
    <h2 *ngIf="loading">Loading ... <activity-indicator></activity-indicator></h2>
    <div *ngIf="error" class="alert alert-danger"><strong>{{error}}</strong></div>
    <div *ngIf="!loading && !error"> 
      <h2>Reports used in browse lists</h2>
      <div style="max-width: 1240px">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Browselist code</th>
              <th>Label</th>
              <th>Report</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let browselist of browselists">
              <td>
                <a uiSref="${STATE_BROWSELIST}" [uiParams]="{listCode: browselist.code}" target="_blank">{{ browselist.code }}</a>
              </td>
              <td>
                {{ browselist.label }}
              </td>
              <td>
                <a uiSref="${STATE_REPORT}" [uiParams]="{reportId: browselist.reportId, showfilters: true}" target="_blank">{{ browselist.reportId }}. {{ browselist.reportName }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `
})
export class BrowselistUsageComponent implements OnInit, OnDestroy {
  public loading:boolean;
  public error:string;
  public browselists: {
    code?: string;
    label?: string;
    reportId?: number;
    reportName?:string;
  } [] = [];


  constructor(
    private authService:AuthService,
    private browseListConfigService:BrowseListConfigService,
    private reportDataService:ReportDataService,
    private responsiveService:ResponsiveService
  ) {
    if (!authService.checkAcslUser()) {
      return;
    }
    responsiveService.width = MaxWidth.LG;
  }

  ngOnInit():void {
    if (!this.authService.checkAcslUser()) {
      this.error = 'You don\'t have access to this page';
      return;
    }

    this.start();

    this.responsiveService.width = MaxWidth.LG;
  }

  private start():void {
    this.loading = true;
    this.reportDataService.loadData(REPORT_ID, REPORT_ID, {}, {})
      .then(this.processBrowselists)
      .finally(() => this.loading = false);
  }

  private processBrowselists = (report:IReportResponse) => {
    const reports:{ [ id:string ]:string; } = {};
    _.each(report.data.data, (row:IReportRow) => {
      const reportId:number = util.extractValue(row.Derepid);
      reports[reportId] = util.extractValue(row.Derepds);
    });

    const browselistConfigs = this.browseListConfigService.getConfigs();
    _.each(browselistConfigs, (config, code) => {
      this.browselists.push({
        code,
        label: config.label,
        reportId: config.reportId,
        reportName: reports[config.reportId]
      });
    });
  };

  ngOnDestroy():void {
    this.responsiveService.width = MaxWidth.SM;
  }


}